import { Injectable } from '@angular/core';
import { UrlHelperService } from '../Common/urlhelper.service';
import { ApiService } from '../Common/api.service';


@Injectable({
  providedIn: 'root'
})
export class MenuService {

    constructor(private _api: ApiService) { }

  GetMenu()
  {
    return this._api.get(UrlHelperService.menu);
  }

}

 




